import update from 'immutability-helper'
import { createReducer } from '@reduxjs/toolkit'

import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE
} from '../actions/user'
import { UpdateUserSuccessPayload } from '../types/user'

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  userData: {},
  isLoading: false
}

export default createReducer(initialState, builder => {
  // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS
  builder
    .addCase(UPDATE_USER, state =>
      update(state, {
        isLoading: { $set: true }
      })
    )
    .addCase(UPDATE_USER_SUCCESS, (state, action: UpdateUserSuccessPayload) =>
      update(state, {
        isLoading: { $set: false },
        userData: { $set: action.userData }
      })
    )
    .addCase(UPDATE_USER_FAILURE, state =>
      update(state, {
        isLoading: { $set: false }
      })
    )
})
